<template>
    <div class="lni-c-box--content lni-u-mhauto lni-u-mv3">
        <lni-child-labor-complaint-confirmation
            id="confirmation"
            :text="text"
        />
    </div>
</template>

<script>
export default {
    name    : 'LniConfirmationPage',
    computed: {
        complaintNumber() {
            return this.$store.state.appState?.complaintNumber;
        },
        text() {
            return this.$store.state.appState?.text;
        },
    },
}; </script>